import ProductsReport from "../../../components/@reports/ProductsReport";

import { routeTypes } from "../../../../../hooks/useSystemRoutes"

export default function ProductsReportPage() {

    return (
        <ProductsReport 
            routeType={routeTypes.admin}
        />
    )
}       